import React, { useEffect, useState } from 'react';

const TokenExpiryHandler = ({ tokenExpiry, recallApi }) => {
	const [timeLeft, setTimeLeft] = useState(null);
	const [isActive, setIsActive] = useState(true);
	const inactivityThreshold = 15000; // 15 seconds (adjust as needed)

	let inactivityTimer = null;

	const handleUserActivity = () => {
		setIsActive(true);

		clearTimeout(inactivityTimer);
		inactivityTimer = setTimeout(() => {
			setIsActive(false);
		}, inactivityThreshold);
	};

	const updateTimeLeft = (expiryDate) => {
		const intervalId = setInterval(() => {
			const currentTime = new Date();
			const timeDifference = expiryDate.getTime() - currentTime.getTime();

			if (timeDifference > 0) {
				setTimeLeft(timeDifference);
			} else {
				clearInterval(intervalId);
				setTimeLeft(0);
			}
		}, 1000);
	};

	const handleVisibilityChange = () => {
		if (document.hidden) {
			setIsActive(false); // Reset activity when tab is inactive
		}
	};

	useEffect(() => {
		const expiryDate = new Date(tokenExpiry);
		updateTimeLeft(expiryDate);

		window.addEventListener('mousemove', handleUserActivity);
		window.addEventListener('keydown', handleUserActivity);
		window.addEventListener('touchstart', handleUserActivity);

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
			window.removeEventListener('mousemove', handleUserActivity);
			window.removeEventListener('keydown', handleUserActivity);
			window.removeEventListener('touchstart', handleUserActivity);
			clearTimeout(inactivityTimer);
		};
	}, [tokenExpiry]);

	useEffect(() => {
		if (timeLeft !== null) {
			const timeInSeconds = Math.floor(timeLeft / 1000);
			if (timeInSeconds < 1) {
				if (!document.hidden && isActive) {
					console.log('Calling the API as user is active and on our page');
					recallApi();
				} else {
					console.log('No activity detected or page is hidden');
				}
			}
		}
	}, [timeLeft, isActive]);

	useEffect(() => {
		console.log('User is active:', isActive);
	}, [isActive]);

	return (
		<div className='timeLeft' style={{ display: 'none' }}>
			{timeLeft !== null && Math.floor(timeLeft / 1000)} seconds
		</div>
	);
};

export default TokenExpiryHandler;
